export default "b888904c06df572f.svg"